import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { getFormMeta, Field, change } from 'redux-form';
import _ from 'lodash';
import GriffinPhone from 'griffin-paypal/lib/client/phone';
import { isValidPhoneNumber, getPhoneTypeOptions, isTelephoneEmpty } from './PhoneFormUtils.js';
import SelectField from '../../../shared-components/SelectField/SelectField';
import { FORM_ID } from '../../../framework/App/AppConstants';
import TextField from '../../../shared-components/TextField/TextField';
import BubbleToolTip from '../../../shared-components/BubbleToolTip/BubbleToolTip';
import CheckBox from '../../../shared-components/CheckBox/CheckBox';
import Col from '../../../shared-components/VXGrid/Col';
import Row from '../../../shared-components/VXGrid/Row';
import { disableTelephone } from '../../pages/PersonalInformationPage/PersonalInformationPageAction';
import './PhoneForm.less';

const LOCALE_PREFIX = 'US/components/PhoneForm/PhoneForm';

export class PhoneForm extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        griffinHandler: PropTypes.object.isRequired,
        isPhoneActive: PropTypes.bool.isRequired,
        disableTelephone: PropTypes.func.isRequired,
        optOutChecked: PropTypes.bool.isRequired,
        showPhoneOptOutCheckbox: PropTypes.bool.isRequired
    };


    toggleTelephone = (event) => {
        this.props.disableTelephone(event);
    };

    render() {
        const { intl, isPhoneActive, griffinHandler, optOutChecked,
            showPhoneOptOutCheckbox } = this.props;
        const label = intl.formatMessage({ id: `${LOCALE_PREFIX}.phone-label` });
        const phoneType = getPhoneTypeOptions(intl, LOCALE_PREFIX);
        let tcpaText;
        let ariadescribedby;
        let optOutText;

        // Show TCPA when the phone number field has focus
        if (isPhoneActive) {
            tcpaText = <BubbleToolTip contents={(<span>{intl.formatMessage({id: `${LOCALE_PREFIX}.TCPA`})}</span>)} id="tcpa-text" />;
            ariadescribedby = 'tcpa-text';
        }

        const disabledText = (optOutChecked) ? 'disabled' : '';

        if (optOutChecked) {
            optOutText = (
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.phone-opt-out-with-important-notice`}
                />
            );
        } else {
            optOutText = intl.formatMessage({id: `${LOCALE_PREFIX}.phone-opt-out`});
        }

        return (
            <div className="PhoneForm">
                {tcpaText}

                <Row gutterSize={10}>
                    <Col xs={4} className="PhoneForm-phoneType-wrapper">
                        <Field
                            id="phone-type"
                            name="phoneType"
                            label={intl.formatMessage({id: `${LOCALE_PREFIX}.phone-type`})}
                            component={SelectField}
                            optionList={phoneType}
                            disabled={optOutChecked}
                        />
                    </Col>
                    <Col xs={8} className="PhoneForm-telephone-wrapper">
                        <Field
                            id="telephone"
                            name="telephone"
                            autoComplete="disabled"
                            autoCorrect="off"
                            autoCapitalize="off"
                            component={TextField}
                            arialabel={label}
                            ariadescribedby={ariadescribedby}
                            type="tel"
                            mask="(999) 999-9999"
                            label={intl.formatMessage({id: `${LOCALE_PREFIX}.phone-label`})}
                            disabled={disabledText}
                            validate={[
                                isTelephoneEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.phone-empty`})),
                                isValidPhoneNumber(griffinHandler,
                                    intl.formatMessage({id: `${LOCALE_PREFIX}.phone-invalid`}))
                            ]}
                        />
                    </Col>
                </Row>

                {showPhoneOptOutCheckbox && (
                    <Field
                        id="phoneOptOut"
                        name="phoneOptOut"
                        label={optOutText}
                        component={CheckBox}
                        onClick={this.toggleTelephone}
                    />)}

            </div>
        );
    }
}

export const mapStateToProps = state => {
    const showPhoneOptOutCheckbox = state.personalInformationPage.showPhoneOptOutCheckbox;
    const optOutChecked = state.personalInformationPage.optOutChecked;

    return {
        griffinHandler: GriffinPhone.createHandler(state.serverData.localityMetadata),
        // Show TCPA when the phone number field has focus
        isPhoneActive: _.get(getFormMeta(FORM_ID)(state), 'telephone.active', false),
        showPhoneOptOutCheckbox,
        optOutChecked
    };
};

export const mapDispatchToProps = dispatch => ({
    disableTelephone(event) {
        dispatch(disableTelephone(event.target.checked));
        dispatch(change(FORM_ID, 'telephone', ''));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PhoneForm));
